import { encodeData } from '@airtel/air-utils';
import { getFromSessionStorage, isSessionSupported } from '../common/commonUtils';
import { getBaseHref } from '../common/environment';

export const navigateToPayment = (onUserAction: any, localData: any, getState: any) => {
   const cancelUrl = new URL(window.location.href);
   const lob = 'CART_ECOM';
   const { storeValues } = getState();

   const msisdn = storeValues?.appData?.msisdn;
   let payableAmount = storeValues?.paymentContext?.paymentAmount;
   let serviceId = storeValues?.paymentContext?.PaymentType;
   const referenceOrderId = storeValues?.cartContext?.cartId;
   const orderItemId = storeValues?.cartContext?.cartItemId;
   let parentJourney = storeValues?.parentJourneyName?.journeyName
   const search = window.location.search;
   const params = new URLSearchParams(search);
   const BASE_HREF = getBaseHref();
   const pathName = window?.location?.pathname
   const landingLayoutOverride = window?.sessionStorage?.getItem("ps_landingLayoutName")

   let journey = params.get('journey');
   let navigationUrl = `https://${window.location.hostname}${BASE_HREF}/thank-you?mobileNumber=${msisdn}&journey=${journey}&orderItemId=${orderItemId}&landingLayoutOverride=${landingLayoutOverride}`;


   if(pathName?.includes("parent-order-summary-new")){
      journey = "P2P"
      navigationUrl = `https://${window.location.hostname}${BASE_HREF}/p2p-payment-loader?mobileNumber=${msisdn}&journey=${journey}&orderItemId=${orderItemId}&landingLayoutOverride=${landingLayoutOverride}`
   }

   if(pathName?.includes("child-order-summary-new")){
      payableAmount = storeValues?.childPaymentContext?.paymentAmount
      serviceId = storeValues?.childPaymentContext?.paymentType
      navigationUrl = `https://${window.location.hostname}${BASE_HREF}/payment-loader?mobileNumber=${msisdn}&journey=${journey}&orderItemId=${orderItemId}&landingLayoutOverride=${landingLayoutOverride}`
   }

   const paymentPayload = createPaymentPayLoadForCom(
      lob,
      msisdn, //provisionSi
      cancelUrl.href,
      payableAmount, //totalPaymentPrice
      navigationUrl,
      serviceId,
      '',
      referenceOrderId, // COM order Id
      msisdn // rtn
   );

   if (paymentPayload) {
      //let url = `https://airtel.in/pay/?payloadData=${paymentPayload}`;

      sessionStorage.setItem('paymentPayload', paymentPayload);

      let url = `https://${window.location.hostname}/pay/?payloadData=${paymentPayload}`;
      sessionStorage.setItem('paymentPayloadUrl', url);

      return onUserAction({
         actions: [
            {
               payload: {
                  args: [],
                  utilName: 'resetOnWebViewCloseCallback',
               },
               type: 'callUtilFunction',
            },
            {
               type: 'navigation',
               payload: { externalUrl: url, shouldAddSearchParams: true },
            },
         ],
      });
   } else {
      return onUserAction({
         actions: [
            {
               type: 'showToast',
               payload: {
                  message: 'Something Went Wrong',
                  duration: 2000,
                  position: 'top',
                  toastType: 'error',
               },
            },
         ],
      });
   }
};

export const createPaymentPayLoadForCom = (
   lob: string,

   provisionSi: string,

   cancelUrl: string,

   price: string,

   thankYouPageUrl: string,

   serviceId: string,

   additionalInfo?: any,

   orderId?: string,

   rtn?: string
) => {
   const paymentObj = {
      lobData:{
         productCategory: "P2P"
      },

      order: {
         ...(orderId && {
            orderId,
         }),

         lobName: lob,

         serviceInstance: provisionSi,

         paymentAmount: price, // paymentAmount = packAmount - coupons

         benefitAmount: price, // benefitAmount = (actual amount without any deduction)

         saveCard: false,

         ...(additionalInfo && {
            additionalInfo,
         }),
      },

      billSummary: {
         paymentAmount: price,

         detailSection: [
            {
               key: serviceId,

               value: `₹${price}`,
            },
         ],
      },

      callBack: {
         redirectionUrl: thankYouPageUrl,

         cancelUrl,
      },

      channelInfo: {
         encodedParams: false,
      },

      flow: {
         isAuthFlow: false,

         ...(rtn && { trackingObj: { eVar6: rtn } }),
      },
   };

   return encodeData(paymentObj);
};

export const handleThanksPageOnLoad = (onUserAction: any, getState: any) => {
   const { storeValues } = getState();

   const actions = [];
   const search = window.location.search;
   const params = new URLSearchParams(search);
   const isCoipUser = !!storeValues?.userData?.isCoipUser || params.get('usertype') == 'COIP';

   const referenceID = params.get('referenceID');
   const mobileNumber = params.get('mobileNumber') || getState()?.storeValues?.appData?.msisdn;
   const orderId = params.get('orderId');
   const orderItemId = params.get('orderItemId');

   let journey = 'addOn';
   if (isSessionSupported()) {
      const journeyType = getFromSessionStorage('journeyType');
      journey = journeyType?.journey;
   }

   const isAddonJourney = journey === 'addOn';
   const { isLeadFlow } = getFromSessionStorage('family_lead_flow') || {};
   const offerStripProps = getFromSessionStorage('bundlingThanksPageData');
   const { offerData, isBundling } = offerStripProps || {};
   let parentJourney = storeValues?.parentJourneyName?.journeyName

   let version = storeValues?.versionContext?.version ?? 'v9';
   if (isAddonJourney) {
      version = 'v1';
   }

   if (referenceID) {
      // no payment case

      const successPayload = {
         type: 'nativeEventEmitter',
         payload: {
            eventName: 'familyThankyouPageStatusCard',
            eventData: {
               id: 'familyThankyouPageStatusCard',
               title: {
                  text: 'Request received',
               },
               subtitle: {
                  text:
                     typeof isLeadFlow !== 'undefined' && isLeadFlow
                        ? 'Thank you for your interest in Airtel Postpaid. Our representative will call you shortly'
                        : isAddonJourney
                        ? 'Thank you for your request. We will be processing your request shortly.'
                        : 'Thank you for your request. Your number will be converted to Airtel postpaid shortly.',
               },
               type: 'svg',
               svg: {
                  iconName: 'TickIcon',
                  svgBackgroundProps: {
                     type: 'LUSH',
                  },
               },
               withCard: true,
               showCollapsible: true,
               collapsibleData: [
                  {
                     title: 'request ID',
                     value: referenceID,
                  },
                  {
                     title: 'contact details',
                     value: mobileNumber,
                  },
               ],
               collapsibleCtaData: {
                  collapseCtaTitle: 'view more',

                  expandedCtaTitle: 'view less',
               },
               offerStripProps: offerData
            },
         },
      };

      let apiUrPostpaidConnections =
         'guardian/api/buy/postpaid/prepaid-to-postpaid/postpaidConnections/' + version;
      if (isAddonJourney) {
         apiUrPostpaidConnections =
            'guardian/api/buy/postpaid/prepaid-to-postpaid/postpaidConnections/addOn/v1';
      }

      actions.push(successPayload);

      if (isBundling) {
         actions.push({
            type: 'nativeEventEmitter',
            payload: {
               eventName: 'benefit_details_widget_bundling',
               eventData: {
                  hideOnPlatforms: [],
               },
            },
         });
         actions.push({
            analyticsAction: 'impression',
            analyticsData: {
               extraData13: '{{storeValues:bundlingJourneyContext.sawBundlingOffer}}',
               extraData7: '{{storeValues:bundlingJourneyContext.postpaidP2P}}',
               eVar9: 'qualified',
               eventCategory: 'family_thankyou_sit',
               customValue: '',
               city: '{{storeValues:userSelectedAddress.city}}',
               leadName: '{{storeValues:familyFormData.userBasicDetails.name}}',
               planName: '{{storeValues:packInfo.planName}}',
               section: 'StatusCardSection',
               feedUserType: '{{sessionStorage:journeyType.feedUserType}}',
               eventAction: 'impression',
               leadAddress: '{{storeValues:userSelectedAddress.addressString}}',
               extraData9:
                  '{{storeValues:bundlingJourneyContext.countOfExistingPostpaid}}',
               extraData6: '{{storeValues:bundlingJourneyContext.bundlingJourneyType}}',
               subSection: 'AirStatusCardWidget',
               leadId: '{{storeValues:cartContext.cartId}}',
               pincode: '{{storeValues:userSelectedAddress.pinCode}}',
               prop8: '{{sessionStorage:journeyType.feedUserType}}',
               eVar18: '{{storeValues:bundlingJourneyContext.countOfExistingBroadband}}',
               eventLabel: offerData?.text || '',
               leadRtn: '{{storeValues:familyFormData.userBasicDetails.alternateNumber}}',
               leadEmail: '{{storeValues:familyFormData.userBasicDetails.email}}',
               extraData11: '{{storeValues:layoutContext.layout}}',
               extraData12: '{{storeValues:cartContext.cartItemId}}',
               extraData10: '{{storeValues:bundlingJourneyContext.countOfExistingDTH}}',
               category: '{{sessionStorage:intentSelected.type}}',
               extraData15: '{{sessionStorage:journeyType.extraData15}}',
               extraData14: '{{storeValues:loggedInContext.extraData14}}',
            },
         });
         
         actions.push({
            analyticsAction: 'impression',
            analyticsData: {
               extraData13: '{{storeValues:bundlingJourneyContext.sawBundlingOffer}}',
               extraData7: '{{storeValues:bundlingJourneyContext.postpaidP2P}}',
               eVar9          : "{{storeValues:isLeadOrOrderContext.isLeadOrOrder}}",
               eventCategory: 'family_thankyou_sit',
               customValue: '',
               city: '{{storeValues:userSelectedAddress.city}}',
               leadName: '{{storeValues:familyFormData.userBasicDetails.name}}',
               planName: '{{storeValues:packInfo.planName}}',
               section: '',
               feedUserType: '{{sessionStorage:journeyType.feedUserType}}',
               eventAction: 'pageloaded',
               leadAddress: '{{storeValues:userSelectedAddress.addressString}}',
               extraData9:
                  '{{storeValues:bundlingJourneyContext.countOfExistingPostpaid}}',
               extraData6: '{{storeValues:bundlingJourneyContext.bundlingJourneyType}}',
               subSection: '',
               leadId: '{{storeValues:cartContext.cartId}}',
               pincode: '{{storeValues:userSelectedAddress.pinCode}}',
               prop8: '{{sessionStorage:journeyType.feedUserType}}',
               eVar18: '{{storeValues:bundlingJourneyContext.countOfExistingBroadband}}',
               eventLabel: '',
               leadRtn: '{{storeValues:familyFormData.userBasicDetails.alternateNumber}}',
               leadEmail: '{{storeValues:familyFormData.userBasicDetails.email}}',
               extraData11: '{{storeValues:layoutContext.layout}}',
               extraData12: '{{storeValues:isLeadOrOrderContext.itemId}}',
               extraData10: '{{storeValues:bundlingJourneyContext.countOfExistingDTH}}',
               category: '{{sessionStorage:intentSelected.type}}',
               extraData15: '{{sessionStorage:journeyType.extraData15}}',
               extraData14: '{{storeValues:loggedInContext.extraData14}}',
            },
         });
         actions.push({
            payload: {
               args: [
                  {
                     stepName: '5|Thank You',
                     offeravailed: '100 off per month',
                     event: 'request_successful',
                  },
               ],
               utilName: 'handleGtmDataLayerEvent',
            },
            type: 'callUtilFunction',
         });
      }

      const experienceApiPayload = {
         type: 'apiCall',
         payload: {
            authTokenGroup: 'FAMILY_PARENT',
            transactUserGroup: null,
            header: {},
            apiUrl: apiUrPostpaidConnections,
            headers: {
               sinumber: mobileNumber,
               channel: isAddonJourney ? storeValues?.manageDetails?.channel : null
            },
            queryParams: {
               orderId: referenceID,
               siNumber: mobileNumber,
               journey,
               scratchCard: true
            },
            requestType: 'GET',
         },
      };

      const showLoaderAction = {
         type: 'nativeEventEmitter',
         payload: {
            eventName: 'PostpaidFamilyConnectionSection_ScrollLinkListWidget',
            eventData: {
               showSkeletonLoader: true,
               skeletonLoaderProps: {
                  fullWidth: true,
                  type: 'list-item',
                  numberOfViews: 1,
                  style: {
                     marginRight: 20,
                     marginLeft: 20,
                     marginTop: 20,
                  },
               },
            },
         },
      };

      if (!isAddonJourney) {
         if (!isLeadFlow && !isCoipUser) {
            actions.push(showLoaderAction);
            actions.push(experienceApiPayload);
         }
      } else {
         actions.push(showLoaderAction);
         actions.push(experienceApiPayload);
      }
   } else if (orderId && orderItemId) {
      let version = getState()?.storeValues?.versionContext?.version ?? 'v9'
      //payment case call order api
      let apiUrGetOrderStatus =
         'guardian/api/buy/postpaid/prepaid-to-postpaid/getOrderStatus/';

      if (isAddonJourney) {
         apiUrGetOrderStatus =
            'guardian/api/buy/postpaid/prepaid-to-postpaid/getOrderStatus/addOn/';
            version = 'v1'
      }

      const pollingCount = params.get('pollingCount');
      const orderPayload = {
         type: 'apiCall',
         payload: {
            requestType: 'GET',
            apiUrl: apiUrGetOrderStatus + version,
            body: {},
            authTokenGroup: 'FAMILY_PARENT',
            transactUserGroup: isAddonJourney ? 'FAMILY_CHILD' : null,
            header: {},
            queryParams: {
               orderId: orderId,
               orderItemId: orderItemId,
               pollingCount: pollingCount ? pollingCount : 1,
               siNumber: mobileNumber,
               journey,
            },
         },
      };

      actions.push(orderPayload);
   }
   return onUserAction({
      actions,
   });
};

export const callPaymentonFailure = (onUserAction: any) => {
   const paymentPayload = sessionStorage.getItem('paymentPayload');
   if (paymentPayload) {
      let url = `https://${window.location.hostname}/pay/?payloadData=${paymentPayload}`;

      return onUserAction({
         actions: [
            {
               type: 'navigation',
               payload: { externalUrl: url, shouldAddSearchParams: true },
            },
         ],
      });
   }
};
